import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20warm%20coral%20and%20cream%20gradients%2C%20overlapping%20translucent%20circles%20and%20organic%20shapes%2C%20modern%20minimalist%20design%2C%20soft%20diffused%20lighting%2C%20artistic%20background%2C%20clean%20elegant%20aesthetic%2C%20no%20text&width=1600&height=900&seq=hero-bg-91jx&orientation=landscape"
        alt="91精选背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      <div className="relative z-10 w-full max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-5 leading-tight tracking-tight">
          发现最值得收藏的
          <br />
          优质内容与资源
        </h1>
        <p className="text-base md:text-lg text-white/85 mb-8 leading-relaxed max-w-[600px] mx-auto">
          91精选汇集海量精选资源，严格筛选每一篇内容，帮您节省时间，快速找到真正有价值的好内容
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/recommended"
            className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-star-line"></i>
            浏览精选推荐
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-7 py-3 bg-background-50/15 text-white backdrop-blur-sm rounded-full text-sm font-medium hover:bg-background-50/25 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-information-line"></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}